import React, { useEffect } from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({
  show,
  onConfirm,
  onCancel,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "accent",
}) => {
  useEffect(() => {
    if (!show) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
      if (e.key === "Enter") onConfirm?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [show, onCancel, onConfirm]);

  if (!show) return null;

  return (
    <div className="cfm-overlay" role="alertdialog" aria-modal="true" aria-labelledby="cfm-title">
      <div className="cfm-backdrop" onClick={onCancel} aria-hidden="true" />
      <div className="cfm-dialog">
        <div className={`cfm-icon-wrap cfm-icon-wrap--${variant}`}>
          {variant === "danger" ? (
            <i className="bi bi-exclamation-triangle-fill" />
          ) : (
            <i className="bi bi-person-check-fill" />
          )}
        </div>
        <h3 id="cfm-title" className="cfm-title">{title}</h3>
        {message && <p className="cfm-message">{message}</p>}
        <div className="cfm-actions">
          <button
            type="button"
            className="cfm-btn cfm-btn--ghost"
            onClick={onCancel}
            autoFocus
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`cfm-btn cfm-btn--${variant}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
